//* 检查css伪类和伪元素在浏览器里是否支持
var supportsPseudoClass = function supportsPseudoClass(clazz) {
  try {
    var _style$sheet;
    var style = document.createElement('style');
    style.innerHTML = clazz + '{}';
    document.head.appendChild(style); // required, or style.sheet === null
    var result = (style == null || (_style$sheet = style.sheet) == null || (_style$sheet = _style$sheet.cssRules) == null ? void 0 : _style$sheet.length) === 1;
    style.remove(); // document.head.removeChild(style);
    return result;
  } catch (error) {
    throw new Error('js error!');
  }
};

export { supportsPseudoClass };
